import { useContext, useState } from "react";
import State from "../../../../../../../../context";
import dayjs from "dayjs";
import { Flex, Input, Select, Table } from "antd";
import MenuActions from "../../../../../../../../atom/MenuActions";

import { isPermissionReadonly } from "../../../../helper";
import { resetCompanyUserPassword } from "../../../../request";

import { SearchOutlined } from "@ant-design/icons";

const SectionUserAll = () => {
  const [state] = useContext(State);
  const [searchedText, setSearchedText] = useState("");

  const getFilteredUsers = list => {
    if (!list) return [];

    if (state.pageUsersFilterType && state.pageUsersFilterType !== "all") {
      list = list?.filter(it => it.type === state.pageUsersFilterType);
    }

    if (
      state.pageUsersFilterOrganization &&
      state.pageUsersFilterOrganization !== "all"
    ) {
      list = list?.filter(
        it => it.company.id === state.pageUsersFilterOrganization
      );
    }

    return list;
  };

  const handleActionResetCompanyUserPassword = ({
    companyId,
    companyUserId,
  }) => {
    resetCompanyUserPassword({
      companyId,
      companyUserId,
      userEmail: state._id,
    })
      .then(() => state.showSuccess("Reset password email sent."))
      .catch(state.showError);
  };

  const columns = [
    {
      filteredValue: [searchedText],
      onFilter: (value, record) =>
        String(record.type)?.toLowerCase()?.includes(value.toLowerCase()) ||
        String(record.firstName)
          ?.toLowerCase()
          ?.includes(value.toLowerCase()) ||
        String(record.lastName)?.toLowerCase()?.includes(value.toLowerCase()) ||
        String(record.email)?.toLowerCase()?.includes(value.toLowerCase()),
      render: allValues => (
        <Flex gap={4} vertical>
          <a
            onClick={() => {
              state.setKeyValue("activeUserId", allValues.id);
              state.setKeyValue("activeSection", "userOne");
            }}
          >
            {allValues.firstName} {allValues.lastName}
          </a>
          <a
            href={`mailto:${allValues.email}`}
            style={{ color: "#4B4747", fontSize: 12 }}
          >
            {allValues.email}
          </a>
        </Flex>
      ),
      title: "Name",
    },
    {
      render: allValues =>
        state.userTypes?.find(it => it.type === allValues.type)?.displayName ??
        allValues.type,
      title: "Type",
    },
    {
      render: allValues =>
        state.listCompanies?.find(it => it.id === allValues.companyId)?.name,
      title: "Organization",
    },
    {
      align: "right",
      render: allValues =>
        allValues.lastLoginTime
          ? dayjs(allValues.lastLoginTime).format("MM/DD/YY, h:mma")
          : "N/A",
      title: "Last Login",
    },
    {
      className: "actions-menu-table-cell",
      render: allValues => (
        <MenuActions
          items={[
            {
              disabled: isPermissionReadonly(state.permissions?.accessLevel),
              key: "edit",
              label: "Edit User",
              onClick: () => {
                state.setKeyValue("activeCompanyId", allValues.companyId);
                state.setKeyValue("activeUserId", allValues.id);
                state.setKeyValue("openModalCompanyUserSettings", true);
              },
            },
            {
              disabled: isPermissionReadonly(state.permissions?.accessLevel),
              key: "reset",
              label: "Reset Password",
              onClick: () =>
                handleActionResetCompanyUserPassword({
                  companyId: allValues.companyId,
                  companyUserId: allValues.id,
                }),
            },
            {
              disabled: isPermissionReadonly(state.permissions?.accessLevel),
              key: "archive",
              label: "Archive User",
              onClick: () => {
                state.setKeyValue("activeCompanyId", allValues.companyId);
                state.setKeyValue("activeUserId", allValues.id);
                state.setKeyValue("openModalCompanyUserArchive", true);
              },
            },
          ]}
        />
      ),
      width: 40,
    },
  ];

  const typeOptions = [
    {
      label: "All",
      value: "all",
    },
    ...(state.userTypes ?? []).map(it => ({
      label: it.displayName,
      value: it.type,
    })),
  ];

  const organizationOptions = [
    {
      label: "All",
      value: "all",
    },
    ...(state.listCompanies ?? []).map(it => ({
      label: it.name,
      value: it.id,
    })),
  ];

  return (
    <>
      <header>
        <h4>All Users</h4>
      </header>

      <main>
        <Flex gap={24}>
          <Input
            allowClear
            onChange={e => setSearchedText(e.target.value)}
            placeholder="Search..."
            size="large"
            style={{ borderRadius: 20, width: 270 }}
            suffix={<SearchOutlined style={{ color: "rgba(0,0,0,.45)" }} />}
            value={searchedText}
          />
          <Flex align="center" gap={8}>
            User Type
            <Select
              onChange={filterType =>
                state.setKeyValue("pageUsersFilterType", filterType)
              }
              options={typeOptions}
              style={{ width: 109 }}
              value={state.pageUsersFilterType}
            />
          </Flex>
          <Flex align="center" gap={8}>
            Organization
            <Select
              onChange={filterOrganization =>
                state.setKeyValue(
                  "pageUsersFilterOrganization",
                  filterOrganization
                )
              }
              options={organizationOptions}
              style={{ width: 160 }}
              value={state.pageUsersFilterOrganization}
            />
          </Flex>
        </Flex>

        <Table
          columns={columns}
          dataSource={getFilteredUsers(
            state.listUsers?.map((it, index) => ({
              ...it,
              key: index,
            }))
          )}
          loading={state.loading}
          pagination={false}
          rowHoverable={false}
          size="small"
        />
      </main>
    </>
  );
};

export default SectionUserAll;
